import { ROLE_SEARCH_START_LOADING, ROLE_SEARCH_END_LOADING, ROLE_SEARCH_LOADED, SET_ROLE_FILTER } from "../constants/RoleConstants";
import { ROLE_START_LOADING, ROLE_END_LOADING, ROLE_LOADED } from "../constants/RoleConstants";

import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadRoleSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ROLE_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("Role/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: ROLE_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ROLE_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ROLE_SEARCH_END_LOADING });
        }
    };
}

export function downloadRoleSearch(filters, documentName) {
    return async (dispatch) => {
            
        await dispatch({ type: ROLE_SEARCH_START_LOADING });

        try {

            var data = await downloadFile("Role/ExportToExcel", filters);
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: ROLE_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ROLE_SEARCH_END_LOADING });
        }
    };
}

export function setRoleFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_ROLE_FILTER,
            payload: filter
        });
    };
}

export function loadRole(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ROLE_START_LOADING });

        try {

            var data = await getApiData("ROLE/GetRoleFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: ROLE_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ROLE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ROLE_END_LOADING });
        }
    };
}

export function saveRole(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ROLE_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("Role/SaveRoleFBO", null, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/role-edit/' + data.responseEntities[0].role.id);
                    dispatch(commonActions.setSuccessMessage("Role Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: ROLE_LOADED,
                        payload: data.responseEntities[0]
                    });
                    
                    dispatch(commonActions.setSuccessMessage("Role Saved Successfully!"));
                }
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ROLE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ROLE_END_LOADING });
        }
    };
}